import { render, staticRenderFns } from "./dialog.vue?vue&type=template&id=572b7908&scoped=true"
import script from "./dialog.vue?vue&type=script&lang=js"
export * from "./dialog.vue?vue&type=script&lang=js"
import style0 from "./dialog.vue?vue&type=style&index=0&id=572b7908&prod&scoped=true&lang=css"
import style1 from "./dialog.vue?vue&type=style&index=1&id=572b7908&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572b7908",
  null
  
)

export default component.exports